import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { AddIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PillButton({
  children,
  onClick,
  tooltipTitle
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: 800,
    delayOnHold: 800,
    placement: "bottom",
    title: tooltipTitle,
    disabled: !tooltipTitle,
    children: /*#__PURE__*/_jsxs(Button, {
      size: "xs",
      use: "tertiary-extra-light",
      onClick: onClick,
      margin: "0",
      "data-test-id": "find-partner-wizard-pill-button",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), children]
    })
  });
}